import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import AdminTabs from '../../components/admin/AdminTabs/AdminTabs';

const AdminPanelPage = () => {
  const isAdmin = localStorage.getItem('role_id') === '1';

  if (!isAdmin) {
    <Box sx={{ width: '90%', margin: '0 auto', mt: 10 }}>
      <Paper
        elevation={3}
        sx={{ p: 2 }}
      >
        <Typography
          variant='h6'
          sx={{ textAlign: 'center' }}
        >
          Доступ запрещен
        </Typography>
        <Typography
          variant='body1'
          sx={{ textAlign: 'center' }}
        >
          Вы не похожи на администратора.
        </Typography>
      </Paper>
    </Box>;
  }

  return <AdminTabs />;
};

export default AdminPanelPage;
